import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AccountMetricsFetchFailedAction = {
	type: 'ACCOUNT_METRICS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AccountMetricsFetchFailedAction => ({
	type: 'ACCOUNT_METRICS_FETCH_FAILED',
	payload,
});
